import Alert, { AlertColor } from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

interface ReusableSnackbarProps {
  open: boolean;
  message: string;
  handleCloseSnackbar: () => void;
  // 4 types of severity, error, info, success, warning
  severity:AlertColor;
  position?:string;
}
const SnackBarErrorResponse = ({
  open,
  message,
  handleCloseSnackbar,
  severity,
  position = 'top', // Default position is top
}: ReusableSnackbarProps) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={2000}
      anchorOrigin={{
        vertical: position === 'bottom' ? 'bottom' : 'top', // Set vertical position based on input
        horizontal: position === 'left' ? 'left' : 'center', // Set horizontal position based on input
      }}
      onClose={() => handleCloseSnackbar()}
    >
      <Alert severity={severity} onClose={() => handleCloseSnackbar()} action={null}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackBarErrorResponse;